import { SCREEN_OFFSET, WIDTH_TRIANGLE } from './tooltipMeasures';
import { TooltipPosition } from '../schema/Tooltip.types';
import { UseTooltipPositionArguments } from '../schema/useTooltipPosition.types';

type CalculateTooltipPositionWithoutAnchorElementParams = Pick<
    UseTooltipPositionArguments,
    'placement' | 'position' | 'toolTip' | 'arrowPosition'
>;

const calculateTooltipPositionWithoutAnchorElement = ({
    placement,
    position = { x: 0, y: 0, arrowLeft: 0 },
    toolTip,
    arrowPosition,
}: CalculateTooltipPositionWithoutAnchorElementParams): TooltipPosition => {
    const toolTipHeight = toolTip.current?.clientHeight ?? 0;
    const toolTipWidth = toolTip.current?.clientWidth ?? 0;

    let top = 0;
    let left = 0;
    let arrowLeft = 0;

    switch (placement) {
        case 'top':
            top = position.y - toolTipHeight - SCREEN_OFFSET;
            left = position.x - toolTipWidth / 2;
            arrowLeft = getPointerPosition(toolTip, arrowPosition);
            break;
        case 'bottom':
            top = position.y + SCREEN_OFFSET;
            left = position.x - toolTipWidth - 2;
            arrowLeft = getPointerPosition(toolTip, arrowPosition);
            break;
        case 'left':
            top = position.y - toolTipHeight - SCREEN_OFFSET;
            left = position.x - toolTipWidth / 2;
            arrowLeft = toolTipWidth;
            break;
        case 'right':
            top = position.y - toolTipHeight - SCREEN_OFFSET;
            left = position.x - toolTipWidth / 2;
            arrowLeft = 0;
            break;
        default:
            break;
    }

    return { ...position, x: left, y: top, arrowLeft };
};

const getPointerPosition = (tooltipElement, arrowPositionPoint) => {
    let pointer = WIDTH_TRIANGLE;
    if (arrowPositionPoint === 'center') {
        pointer = (tooltipElement.current.clientWidth - WIDTH_TRIANGLE) / 2;
    } else if (arrowPositionPoint === 'end') {
        pointer = tooltipElement.current.clientWidth - (3 * WIDTH_TRIANGLE) / 2;
    }
    return pointer;
};

export {
    calculateTooltipPositionWithoutAnchorElement,
    CalculateTooltipPositionWithoutAnchorElementParams,
};
